export default __webpack_public_path__ + "static/media/search-color.449dba38.svg";